import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContingencySettings, Quotation } from 'src/app/interfaces/quotation';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class QuotationService {
  api: string = `${environment.api}/approver/quotation_request`;

  constructor(private http: HttpClient) {}

  find(uuid: string) {
    return this.http.get<Quotation>(`${this.api}/${uuid}`, { observe: 'body' });
  }
  search(
    query: string = '',
    page: number = 1,
    page_size: number = 10,
    status: string = 'For Approval',
    order: string = 'date_desc'
  ) {
    const params = new HttpParams()
      .set('page', page)
      .set('page_size', page_size)
      .set('query', query)
      .set('status', status)
      .set('order', order);
    return this.http.get<{ count: number; items: Quotation[] }>(`${this.api}`, {
      observe: 'body',
      params: params,
    });
  }
  approval(
    uuid: string,
    formData: FormData,
    approval: 'approved' | 'revision',
    reason: string = ''
  ) {
    formData.set('approval', approval);
    formData.set('reason', reason);

    return this.http.post(`${this.api}/${uuid}/approval`, formData, {
      observe: 'response',
    });
  }

  // quotation configurations
  getContingency() {
    return this.http.get<ContingencySettings>(`${this.api}/contingency`);
  }
  updateContingency(payload: { percent: number | null }) {
    return this.http.patch(`${this.api}/contingency`, payload);
  }
}
